import APP from 'src/main.js'
import Event from './Event.js'

class TradeCostCancel extends Event {
    get trade_cost(){
        let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.child_id===this.id)&&(rel.parent_type==='TradeCost'))||{}).parent_id
        if(value){
            return this.constructor.employeeStore.events.find(ev => (ev.id===value)&&ev.id)
        } else {
            return null
        }
    }
    get trade_cost_expected(){
        let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.child_id=== this.id)&&(rel.parent_type==='TradeCostExpected'))||{}).parent_id
        if(value){
            return this.constructor.employeeStore.events.find(ev => (ev.id===value)&&ev.id)
        } else {
            return null
        }
    }
}
export default TradeCostCancel
